<template>
	<div class="newDesBox">
		<div class="banner">
			<p class="txt">NEWS<br />新闻资讯</p>
		</div>
		<div class="titleList flexBox"><router-link to="/new"
				class="txt">新闻资讯</router-link><i>></i><span>{{des.title}}</span></div>
		<div class="desBox">
			<div class="name">{{des.title}}</div>
			<div class="time">{{des.publishTime}}</div>
			<div class="txt ql-editor" v-html="des.content" style="white-space: pre-wrap;"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'NewDes',
		components: {

		},
		data() {
			return {
				des:{}
			}
		},
		mounted() {
			var id = this.$route.query.id;
			if(id != undefined){
				this.$req("get", "/api/cms/news/"+id).then((res) => {
					this.des = res.data
				})
			}
		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/portal/newDes.css");
</style>